import React from "react";
import * as Icons from "react-icons/vsc";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, matchPath } from "react-router-dom";

/**
 * 
 * @param {*} param0 
 * @returns 
 * match path
 */

function SidebarLink({ link, iconName }) {
  const Icon = Icons[iconName]; // fetch using icon name
  const location = useLocation();
  const dispatch = useDispatch();

  const matchRoute = (route) => {
    // to mark where we are in the dashboard
    return matchPath({ path: route }, location.pathname);
  };

  return (
    <NavLink
      to={link.path}
      className={`relative px-8 py-2 text-sm font-medium ${
        matchRoute(link.path) ? "bg-[#3D2A01] text-[#FFD60A]" : "text-richblack-25 bg-opacity-0"
      }`}>
      {/* 
                className={`relative px-8 py-2 text-sm font-medium ${matchRoute(link.path) ? ("bg-[#3D2A01] border-l border-[#FFD60A] text-[#FFD60A]") : ("bg-opacity-0")}`}
            */}
      <span
        className={`absolute left-0 top-0 h-full w-[0.2rem] bg-yellow-50 ${
          matchRoute(link.path) ? "opacity-100" : "opacity-0"
        }`}></span>
      <div className="flex items-center gap-2">
        <Icon className="text-lg" />
        <p>{link.name}</p>
      </div>
    </NavLink>
  );
}

export default SidebarLink;
